// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__7lbNC","action":"style_action__t5gpi","action_btn":"style_action_btn__JuFhd"};